import { render, staticRenderFns } from "./ServiceAccountEditAction.vue?vue&type=template&id=2ddfd69f"
import script from "./ServiceAccountEditAction.vue?vue&type=script&lang=js"
export * from "./ServiceAccountEditAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports